import { useSyncExternalStore } from 'react'
import { Logger } from '@/components/Logger'
import { LocalStorageKeys } from '@/constants/localstorage'

type Listener = () => void

const listeners = new Set<Listener>()

const notify = () => {
  listeners.forEach((listener) => listener())
}

export const getApiKey = () => {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage.getItem(LocalStorageKeys.API_KEY)
  } catch (error) {
    Logger.error('ApiKeyAuth: unable to read api key from sessionStorage', error)
    return null
  }
}

export const setApiKey = (apiKey: string | null) => {
  if (typeof window !== 'undefined') {
    try {
      if (apiKey) {
        window.sessionStorage.setItem(LocalStorageKeys.API_KEY, apiKey)
      } else {
        window.sessionStorage.removeItem(LocalStorageKeys.API_KEY)
      }
    } catch (error) {
      Logger.error('ApiKeyAuth: unable to persist api key to sessionStorage', error)
    }
  }

  notify()
}

export const subscribeApiKey = (listener: Listener) => {
  listeners.add(listener)

  const handleStorage = (event: StorageEvent) => {
    if (event.key === LocalStorageKeys.API_KEY) {
      listener()
    }
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('storage', handleStorage)
  }

  return () => {
    listeners.delete(listener)
    if (typeof window !== 'undefined') {
      window.removeEventListener('storage', handleStorage)
    }
  }
}

export const useApiKey = () => useSyncExternalStore(subscribeApiKey, getApiKey, () => null)
